import TwoWayMessaging from '../dashboard/two_way_messaging/two_way_messaging';

class DashboardV2 {
  init() {
    new TwoWayMessaging().init();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.js-dashbaord-v2')) {
    new DashboardV2().init();
  }
});

